import { cloneDeep } from 'lodash';

import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UploadDocumentParentService } from '../utils/upload-document-parent.service';
import { ExtensionDocumentPipe } from '../../../filters/extension-document/extension-document.pipe';
import { ConvertBytesPipe } from '../../../filters/convert-bytes/convert-bytes.pipe';
import { FormsModule } from '@angular/forms';
import { DropZoneDirective } from '../../../directives/drop-zone/drop-zone.directive';
import { NgClass, NgStyle } from '@angular/common';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { FieldTypeListSimpleComponent } from "../../field-type-list/field-type-list-simple/field-type-list-simple.component";
import { FieldTypeTextMultilineComponent } from "../../field-type-text/field-type-text-multiline/field-type-text-multiline.component";
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { AdviceMessageComponent } from "../../advice-message/advice-message.component";
import { SpanTooltipComponent } from '@shared/components/span-tooltip/span-tooltip.component';

@Component({
    selector: 'upload-documents-modal',
    templateUrl: './upload-documents-modal.component.html',
    standalone: true,
    imports: [
    AfTranslateDirective,
    NgClass,
    DropZoneDirective,
    NgStyle,
    FormsModule,
    ConvertBytesPipe,
    ExtensionDocumentPipe,
    FieldTypeListSimpleComponent,
    FieldTypeTextMultilineComponent,
    AdviceMessageComponent,
    SpanTooltipComponent
]
})
export class UploadDocumentsModalComponent implements OnInit {
  conceptObjectId: any = this.route.snapshot.params['conceptObjectId'];
  isLanding: Boolean = this.customLanding.isLanding();
  component: any= this.dialogConfig.data.component;
  type: string = this.dialogConfig.data.type;
  files: any = this.dialogConfig.data.files;
  documentationList: any = this.dialogConfig.data.documentationList;
  itemSelected: any = this.dialogConfig.data.itemSelected;
  listSelect: any = this.dialogConfig.data.listSelect;
  uploadDocuments: any = this.uploadDocumentParent.configureUploadDocuments(this);

  constructor(private uploadDocumentParent: UploadDocumentParentService,
    private route: ActivatedRoute,
    private customLanding: CustomLandingFactory,
    private dialogRef: DynamicDialogRef<UploadDocumentsModalComponent>,
    private dialogConfig: DynamicDialogConfig) {
  }

  @Output() uploadDocumentsEmit = new EventEmitter();

  ngOnInit(): void {
    this.uploadDocuments.newConceptLanding = this.isLanding && this.itemSelected && !this.itemSelected.conceptObjectId && this.itemSelected.communicationChannel && this.itemSelected.publicShared;
    this.uploadDocuments.showProcess = this.type === 'addNewDocumentsFromProcessModal' || ((this.type === 'addNewDocuments'  || this.type === 'addNewDocumentsToFields') && this.listSelect && this.listSelect.length);
    this.uploadDocuments.processSteps.required = this.type === 'addNewDocumentsFromProcessModal' && this.uploadDocuments.showProcess;
    this.uploadDocuments.component = cloneDeep(this.component);
    this.uploadDocuments.documentationList = cloneDeep(this.documentationList);

    if(this.files.length){
      this.uploadDocumentParent.dropNewDocument(this.files, this);
    }
  }

  dropNewDocument(e:any){
    this.uploadDocumentParent.dropNewDocument(e.files, this)
    this.uploadDocumentsEmit.emit({uploadDocuments:this.uploadDocuments.upDocuments})
  }

  uploadFiles(){
    this.uploadDocumentParent.uploadFiles(this)
  }

  addDocument(document:any, firstLoad:any){
    this.uploadDocumentParent.addDocument(document, firstLoad, this, false)
  }

  loadFiles(event:any){
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    this.uploadDocumentParent.loadFiles(files, this)
  }

  itemSelectedList(e:any, item:string){
    this.uploadDocumentParent.itemSelectedList( item, e.newValue, this)
  }

  openFileSearch(){
    this.uploadDocumentParent.openFileSearch()
  }

  deleteDocument(index:any){
    this.uploadDocumentParent.deleteDocument(index, this)
  }

  openTextareaModal(){
    this.uploadDocumentParent.openTextareaModal(this)
  }

  renameDocument(document:any){
    this.uploadDocumentParent.renameDocument(document, this)
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      files: this.uploadDocuments.filesUpdate,
      comments: this.uploadDocuments.comments,
      failed: this.uploadDocuments.failedUploads,
      stateId: this.uploadDocuments.stateId,
      nameState: this.uploadDocuments.nameState
    })
  }

  handleDismiss() {
    if(this.uploadDocuments.filesUpdate.length === 0){
      this.dialogRef.close({result:'cancel'});
    }else{
        this.handleAccept();
    }
  }
}
